export function getWishlistDisplayName(name: string) {
  return name === 'default' ? 'Meine Wunschliste' : name
}
